<div class="container" [ngClass]="themeClass">
  <app-top-menu [theme]="themeClass"></app-top-menu>
  <div *ngIf="isLoading()" class="busy-counter">
    <mat-spinner></mat-spinner>
  </div>
  
  <!-- Component Outlet -->
  <div class="content-display">
    <router-outlet></router-outlet>
  </div>
</div>
